<template>
  <div class="account">
    <a-row class="card-row" :gutter="20">
      <a-col :md="16" :span="24" :class="{ 'mb-20': !isDesktop }">
        <Welcome></Welcome>
      </a-col>
      <a-col :md="8" :span="24">
        <UserInfo></UserInfo>
      </a-col>
    </a-row>
    <div class="card-row">
      <a-spin :spinning="spinning"><Activities></Activities></a-spin>
    </div>
    <div class="card-row">
      <a-row :gutter="20">
        <a-col :md="12" :span="24">
          <TrendChart></TrendChart>
        </a-col>
        <a-col :md="12" :span="24">
          <Top5Countries></Top5Countries>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Welcome from './components/Welcome'
import UserInfo from './components/UserInfo'
import Activities from './components/Activities'
import TrendChart from './components/TrendChart'
import Top5Countries from './components/Top5Countries'
import { mapState } from 'vuex'

export default {
  name: 'Account',
  components: { Welcome, UserInfo, Activities, TrendChart, Top5Countries },
  computed: {
    ...mapState({
      spinning: (state) => state.link.spinning,
    }),
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  created() {
    this.$store.dispatch('user/afterLogin')
  },
}
</script>

<style lang="scss" scoped>
.account {
  padding: 0 10px;
  .card-row {
    margin: 20px auto;
    // display: flex;
    // justify-content: space-between;
  }
}
</style>
